import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Radio,
  Button
} from 'semantic-ui-react'

const CardNaranjoAlgorithmUX = (props: any) => {
    return(
      <div>
        <div
          id="CardNaranjoAlgorithmUX-div-1"
          style={{ display: "flex" , border: "solid 1px rgb(200, 200, 200, 0.5)","backgroundColor":"rgb(161, 221, 230)", justifyContent: "space-between", alingItem: "center", height: "70px" }}>
          
          <div
            id="CardNaranjoAlgorithmUX-div-2"
            style={{ padding: " 22px 50px 0px", fontWeight: "bold", fontSize: "17px"}}>
            {props.languageUX === "en" ? "Naranjo Algorithm" : "อัลกอริทึม Naranjo"}
          </div>
        </div>
        <div
          id="CardNaranjoAlgorithmUX-div-3"
          style={{ margin: "0px 50px"}}>
          
          <div
            id="CardNaranjoAlgorithmUX-div-11"
            style={{ display: "flex"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-12"
              style={{ padding: "10px", width: "60%",}}>
              
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-13"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", }}>
              
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-14"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.languageUX === "en" ? "score" : "คะแนน"}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-4"
            style={{ display: "flex", border: "solid gray 2px"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-5"
              style={{ padding: "10px", width: "60%", borderRight: "solid gray 2px", "backgroundColor":"rgb(161, 221, 230,0.49)",}}>
              {props.languageUX === "en" ? "1. Has this reaction ever been summarized or reported?" : "1. เคยมีสรุปหรือรายงานปฏิกิริยานี้มาแล้วหรือไม่"}
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-6"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", borderRight: "solid gray 2px"}}>
              
              <Radio
                checked={props.naranjo?.["1"] === "YES" }
                id="CardNaranjoAlgorithmUX-Radio-Yes-q1"
                label={props.languageUX === "en" ? "yes" : "ใช่"}
                name="1"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="YES">
              </Radio>
              <Radio
                checked={props.naranjo?.["1"] === "NO"}
                id="CardNaranjoAlgorithmUX-Radio-No-q1"
                label="ไม่ใช่ "
                name="1"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NO">
              </Radio>
              <Radio
                checked={props.naranjo?.["1"] === "NA"}
                id="CardNaranjoAlgorithmUX-Radio-NA-q1"
                label={props.languageUX === "en" ? "I don't know." : "ไม่ทราบ"}
                name="1"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NA">
              </Radio>
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-7"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.score?.["1"] || 0}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-15"
            style={{ display: "flex", border: "solid gray 2px"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-16"
              style={{ padding: "10px", width: "60%", borderRight: "solid gray 2px", "backgroundColor":"rgb(161, 221, 230,0.49)",}}>
              {props.languageUX === "en" ? "2. The adverse reaction occurred after the patient received the suspected drug." : "2. อาการไม่พึงประสงค์นั้นเกิดขึ้นภายหลังผู้ป่วยได้รับยาที่สงสัย"}
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-17"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", borderRight: "solid gray 2px"}}>
              
              <Radio
                checked={props.naranjo?.["2"] === "YES" }
                id="CardNaranjoAlgorithmUX-Radio-Yes-q2"
                label={props.languageUX === "en" ? "yes" : "ใช่"}
                name="2"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="YES">
              </Radio>
              <Radio
                checked={props.naranjo?.["2"] === "NO" }
                id="CardNaranjoAlgorithmUX-Radio-No-q2"
                label={props.languageUX === "en" ? "no" : "ไม่ใช่"}
                name="2"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NO">
              </Radio>
              <Radio
                checked={props.naranjo?.["2"] === "NA" }
                id="CardNaranjoAlgorithmUX-Radio-NA-q2"
                label={props.languageUX === "en" ? "I don't know." : "ไม่ทราบ"}
                name="2"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NA">
              </Radio>
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-18"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.score?.["2"] || 0}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-22"
            style={{ display: "flex", border: "solid gray 2px"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-30"
              style={{ padding: "10px", width: "60%", borderRight: "solid gray 2px", "backgroundColor":"rgb(161, 221, 230,0.49)",}}>
              {props.languageUX === "en" ? "3. The adverse reaction subsides when the suspected drug is discontinued or when a specific antagonist is given." : "3. อาการไม่พึงประสงค์นั้นบรรเทาลงเมื่อหยุดยาที่สงสัยหรือเมื่อมีการให้ specific antagonist"}
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-38"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", borderRight: "solid gray 2px"}}>
              
              <Radio
                checked={props.naranjo?.["3"] === "YES" }
                id="CardNaranjoAlgorithmUX-Radio-Yes-q3"
                label={props.languageUX === "en" ? "yes" : "ใช่"}
                name="3"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="YES">
              </Radio>
              <Radio
                checked={props.naranjo?.["3"] === "NO" }
                id="CardNaranjoAlgorithmUX-Radio-No-q3"
                label={props.languageUX === "en" ? "no" : "ไม่ใช่"}
                name="3"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NO">
              </Radio>
              <Radio
                checked={props.naranjo?.["3"] === "NA" }
                id="CardNaranjoAlgorithmUX-Radio-NA-q3"
                label={props.languageUX === "en" ? "I don't know." : "ไม่ทราบ"}
                name="3"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NA">
              </Radio>
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-70"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.score?.["3"] || 0}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-23"
            style={{ display: "flex", border: "solid gray 2px"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-31"
              style={{ padding: "10px", width: "60%", borderRight: "solid gray 2px", "backgroundColor":"rgb(161, 221, 230,0.49)",}}>
              {props.languageUX === "en" ? "4. The adverse effect recurs when the drug is used again." : "4. อาการไม่พึงประสงค์นั้นกลับเป็นซ้ำเมื่อมีการใช้ยานั้นอีก"}
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-39"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", borderRight: "solid gray 2px"}}>
              
              <Radio
                checked={props.naranjo?.["4"] === "YES" }
                id="CardNaranjoAlgorithmUX-Radio-Yes-q4"
                label={props.languageUX === "en" ? "yes" : "ใช่"}
                name="4"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="YES">
              </Radio>
              <Radio
                checked={props.naranjo?.["4"] === "NO" }
                id="CardNaranjoAlgorithmUX-Radio-No-q4"
                label={props.languageUX === "en" ? "no" : "ไม่ใช่"}
                name="4"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NO">
              </Radio>
              <Radio
                checked={props.naranjo?.["4"] === "NA" }
                id="CardNaranjoAlgorithmUX-Radio-NA-q4"
                label={props.languageUX === "en" ? "I don't know." : "ไม่ทราบ"}
                name="4"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NA">
              </Radio>
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-71"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.score?.["4"] || 0}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-24"
            style={{ display: "flex", border: "solid gray 2px"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-32"
              style={{ padding: "10px", width: "60%", borderRight: "solid gray 2px", "backgroundColor":"rgb(161, 221, 230,0.49)",}}>
              {props.languageUX === "en" ? "5. There may be other causes besides the suspected drug that are causing the patient to have the adverse symptoms." : "5. อาจมีสาเหตุอื่นนอกเหนือจากยาที่สงสัยซึ่งเป็นสาเหตุให้ผู้ป่วย มีอาการไม่พึงประสงค์นั้น"}
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-40"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", borderRight: "solid gray 2px"}}>
              
              <Radio
                checked={props.naranjo?.["5"] === "YES" }
                id="CardNaranjoAlgorithmUX-Radio-Yes-q5"
                label={props.languageUX === "en" ? "yes" : "ใช่"}
                name="5"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="YES">
              </Radio>
              <Radio
                checked={props.naranjo?.["5"] === "NO" }
                id="CardNaranjoAlgorithmUX-Radio-No-q5"
                label={props.languageUX === "en" ? "no" : "ไม่ใช่"}
                name="5"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NO">
              </Radio>
              <Radio
                checked={props.naranjo?.["5"] === "NA" }
                id="CardNaranjoAlgorithmUX-Radio-NA-q5"
                label={props.languageUX === "en" ? "I don't know." : "ไม่ทราบ"}
                name="5"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NA">
              </Radio>
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-72"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.score?.["5"] || 0}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-25"
            style={{ display: "flex", border: "solid gray 2px"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-33"
              style={{ padding: "10px", width: "60%", borderRight: "solid gray 2px", "backgroundColor":"rgb(161, 221, 230,0.49)",}}>
              {props.languageUX === "en" ? "6. Did this reaction occur again when given a placebo?" : "6. ปฏิกิริยาดังกล่าวนี้เกิดขึ้นอีกเมื่อให้ยาหลอกหรือไม่"}
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-41"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", borderRight: "solid gray 2px"}}>
              
              <Radio
                checked={props.naranjo?.["6"] === "YES" }
                id="CardNaranjoAlgorithmUX-Radio-Yes-q6"
                label={props.languageUX === "en" ? "yes" : "ใช่"}
                name="6"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="YES">
              </Radio>
              <Radio
                checked={props.naranjo?.["6"] === "NO" }
                id="CardNaranjoAlgorithmUX-Radio-No-q6"
                label={props.languageUX === "en" ? "no" : "ไม่ใช่"}
                name="6"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NO">
              </Radio>
              <Radio
                checked={props.naranjo?.["6"] === "NA" }
                id="CardNaranjoAlgorithmUX-Radio-NA-q6"
                label={props.languageUX === "en" ? "I don't know." : "ไม่ทราบ"}
                name="6"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NA">
              </Radio>
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-73"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.score?.["6"] || 0}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-26"
            style={{ display: "flex", border: "solid gray 2px"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-34"
              style={{ padding: "10px", width: "60%", borderRight: "solid gray 2px", "backgroundColor":"rgb(161, 221, 230,0.49)",}}>
              {props.languageUX === "en" ? "7. The drug level in the blood or other body fluid has been measured and the value indicates a toxic level." : "7. มีการวัดระดับยาในเลือดหรือใน body fluid อื่น และค่าดังกล่าว แสดงถึงระดับที่เป็นพิษ"}
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-42"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", borderRight: "solid gray 2px"}}>
              
              <Radio
                checked={props.naranjo?.["7"] === "YES" }
                id="CardNaranjoAlgorithmUX-Radio-Yes-q7"
                label={props.languageUX === "en" ? "yes" : "ใช่"}
                name="7"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="YES">
              </Radio>
              <Radio
                checked={props.naranjo?.["7"] === "NO" }
                id="CardNaranjoAlgorithmUX-Radio-No-q7"
                label={props.languageUX === "en" ? "no" : "ไม่ใช่"}
                name="7"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NO">
              </Radio>
              <Radio
                checked={props.naranjo?.["7"] === "NA" }
                id="CardNaranjoAlgorithmUX-Radio-NA-q7"
                label={props.languageUX === "en" ? "I don't know." : "ไม่ทราบ"}
                name="7"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NA">
              </Radio>
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-74"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.score?.["7"] || 0}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-27"
            style={{ display: "flex", border: "solid gray 2px"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-35"
              style={{ padding: "10px", width: "60%", borderRight: "solid gray 2px", "backgroundColor":"rgb(161, 221, 230,0.49)",}}>
              {props.languageUX === "en" ? "8. The adverse reaction is more severe when the dose is increased and/or the adverse reaction is less severe when the dose is decreased." : "8. อาการไม่พึงประสงค์นั้นรุนแรงขึ้นเมื่อมีการเพิ่มขนาดยาและ/หรืออาการไม่พึงประสงค์นั้นลดความรุนแรงลงเมื่อลดขนาดยา"}
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-43"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", borderRight: "solid gray 2px"}}>
              
              <Radio
                checked={props.naranjo?.["8"] === "YES" }
                id="CardNaranjoAlgorithmUX-Radio-Yes-q8"
                label={props.languageUX === "en" ? "yes" : "ใช่"}
                name="8"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="YES">
              </Radio>
              <Radio
                checked={props.naranjo?.["8"] === "NO" }
                id="CardNaranjoAlgorithmUX-Radio-No-q8"
                label={props.languageUX === "en" ? "no" : "ไม่ใช่"}
                name="8"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NO">
              </Radio>
              <Radio
                checked={props.naranjo?.["8"] === "NA" }
                id="CardNaranjoAlgorithmUX-Radio-NA-q8"
                label={props.languageUX === "en" ? "I don't know." : "ไม่ทราบ"}
                name="8"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NA">
              </Radio>
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-75"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.score?.["8"] || 0}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-28"
            style={{ display: "flex", border: "solid gray 2px"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-36"
              style={{ padding: "10px", width: "60%", borderRight: "solid gray 2px", "backgroundColor":"rgb(161, 221, 230,0.49)",}}>
              {props.languageUX === "en" ? "9. Has the patient ever shown such adverse reactions in the past when taking the suspected drug or similar drugs?" : "9. ผู้ป่วยเคยแสดงอาการไม่พึงประสงค์เช่นนี้มาก่อนในอดีตเมื่อใช้ยาที่สงสัย หรือยาที่คล้ายกัน"}
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-44"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", borderRight: "solid gray 2px"}}>
              
              <Radio
                checked={props.naranjo?.["9"] === "YES" }
                id="CardNaranjoAlgorithmUX-Radio-Yes-q9"
                label={props.languageUX === "en" ? "yes" : "ใช่"}
                name="9"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="YES">
              </Radio>
              <Radio
                checked={props.naranjo?.["9"] === "NO" }
                id="CardNaranjoAlgorithmUX-Radio-No-q9"
                label={props.languageUX === "en" ? "no" : "ไม่ใช่"}
                name="9"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NO">
              </Radio>
              <Radio
                checked={props.naranjo?.["9"] === "NA" }
                id="CardNaranjoAlgorithmUX-Radio-NA-q9"
                label={props.languageUX === "en" ? "I don't know." : "ไม่ทราบ"}
                name="9"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NA">
              </Radio>
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-76"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.score?.["9"] || 0}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-29"
            style={{ display: "flex", border: "solid gray 2px"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-37"
              style={{ padding: "10px", width: "60%", borderRight: "solid gray 2px", "backgroundColor":"rgb(161, 221, 230,0.49)",}}>
              {props.languageUX === "en" ? "10. Such adverse reactions can be confirmed with objective data." : "10. สามารถยืนยันอาการไม่พึงประสงค์ดังกล่าวได้ด้วย objective data"}
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-45"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "30%", borderRight: "solid gray 2px"}}>
              
              <Radio
                checked={props.naranjo?.["10"] === "YES" }
                id="CardNaranjoAlgorithmUX-Radio-Yes-q10"
                label={props.languageUX === "en" ? "yes" : "ใช่"}
                name="10"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="YES">
              </Radio>
              <Radio
                checked={props.naranjo?.["10"] === "NO" }
                id="CardNaranjoAlgorithmUX-Radio-No-q10"
                label={props.languageUX === "en" ? "no" : "ไม่ใช่"}
                name="10"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NO">
              </Radio>
              <Radio
                checked={props.naranjo?.["10"] === "NA" }
                id="CardNaranjoAlgorithmUX-Radio-NA-q10"
                label={props.languageUX === "en" ? "I don't know." : "ไม่ทราบ"}
                name="10"
                onChange={props.onChangeNaranjo}
                style={{marginLeft:"25px"}}
                value="NA">
              </Radio>
            </div>
            <div
              id="CardNaranjoAlgorithmUX-div-77"
              style={{ display: "flex", justifyContent: "center", padding: "10px", width: "10%", }}>
              {props.score?.["10"] || 0}
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-78"
            style={{ display: "flex", justifyContent: "flex-end"}}>
            
            <div
              id="CardNaranjoAlgorithmUX-div-80"
              style={{ justifyContent: "space-between", display: "flex", padding: "10px", width: "65%", borderRight: "solid gray 2px", backgroundColor:"rgba(255, 208, 43, 0.46)",}}>
              
              <div
                id="CardNaranjoAlgorithmUX-div-81"
                style={{ margin: "0px 30px", display: "flex", color: "#1B75BB",  fontWeight: "bold", fontSize: "17px"}}>
                
                <div
                  id="CardNaranjoAlgorithmUX-div-83">
                  {props.languageUX === "en" ? "Total score :" : "คะแนนรวม :"}
                </div>
                <div
                  id="CardNaranjoAlgorithmUX-div-84"
                  style={{ margin: "0px 10px"}}>
                  {props.naranjo?.score || 0}
                </div>
              </div>
              <div
                id="CardNaranjoAlgorithmUX-div-82"
                style={{ margin: "0px 30px", display: "flex", color: "#1B9D2C",  fontWeight: "bold", fontSize: "17px"}}>
                
                <div
                  id="CardNaranjoAlgorithmUX-div-85">
                  ผลการประเมิน: 
                </div>
                <div
                  id="CardNaranjoAlgorithmUX-div-86"
                  style={{ margin: "0px 10px"}}>
                  {props.naranjo?.status || ""}
                </div>
              </div>
            </div>
          </div>
          <div
            id="CardNaranjoAlgorithmUX-div-79"
            style={{ display: "flex", justifyContent: "flex-end", margin: "20px 0px" }}>
            
            <Button
              color="green"
              id="CardNaranjoAlgorithmUX-Button-87"
              onClick={props.onSave}>
              {props.languageUX === "en" ? "record" : "บันทึก"}
            </Button>
            <Button
              color="red"
              id="CardNaranjoAlgorithmUX-Button-88"
              onClick={props.onCencel}>
              {props.languageUX === "en" ? "cancel" : "ยกเลิก"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardNaranjoAlgorithmUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" , border: \"solid 1px rgb(200, 200, 200, 0.5)\",\"backgroundColor\":\"rgb(161, 221, 230)\", justifyContent: \"space-between\", alingItem: \"center\", height: \"70px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "อัลกอริทึม Naranjo",
          "valueEN": "Naranjo Algorithm"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \" 22px 50px 0px\", fontWeight: \"bold\", fontSize: \"17px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 50px\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"solid gray 2px\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "1. เคยมีสรุปหรือรายงานปฏิกิริยานี้มาแล้วหรือไม่",
          "valueEN": "1. Has this reaction ever been summarized or reported?"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\", borderRight: \"solid gray 2px\", \"backgroundColor\":\"rgb(161, 221, 230,0.49)\",}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", borderRight: \"solid gray 2px\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.score?.[\"1\"] || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Radio",
      "parent": 6,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"1\"] === \"YES\" "
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-Yes-q1"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "name": {
          "type": "value",
          "value": "1"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "YES"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Radio",
      "parent": 6,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"1\"] === \"NO\""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-No-q1"
        },
        "label": {
          "type": "value",
          "value": "ไม่ใช่ "
        },
        "name": {
          "type": "value",
          "value": "1"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NO"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Radio",
      "parent": 6,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"1\"] === \"NA\""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-NA-q1"
        },
        "label": {
          "type": "value",
          "value": "ไม่ทราบ",
          "valueEN": "I don't know."
        },
        "name": {
          "type": "value",
          "value": "1"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\",}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "คะแนน",
          "valueEN": "score"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"solid gray 2px\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "2. อาการไม่พึงประสงค์นั้นเกิดขึ้นภายหลังผู้ป่วยได้รับยาที่สงสัย",
          "valueEN": "2. The adverse reaction occurred after the patient received the suspected drug."
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\", borderRight: \"solid gray 2px\", \"backgroundColor\":\"rgb(161, 221, 230,0.49)\",}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", borderRight: \"solid gray 2px\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "props.score?.[\"2\"] || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Radio",
      "parent": 17,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"2\"] === \"YES\" "
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-Yes-q2"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "name": {
          "type": "value",
          "value": "2"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "YES"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Radio",
      "parent": 17,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"2\"] === \"NO\" "
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-No-q2"
        },
        "label": {
          "type": "value",
          "value": "ไม่ใช่",
          "valueEN": "no"
        },
        "name": {
          "type": "value",
          "value": "2"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NO"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Radio",
      "parent": 17,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"2\"] === \"NA\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-NA-q2"
        },
        "label": {
          "type": "value",
          "value": "ไม่ทราบ",
          "valueEN": "I don't know."
        },
        "name": {
          "type": "value",
          "value": "2"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"solid gray 2px\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"solid gray 2px\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"solid gray 2px\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"solid gray 2px\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"solid gray 2px\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"solid gray 2px\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"solid gray 2px\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", border: \"solid gray 2px\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "3. อาการไม่พึงประสงค์นั้นบรรเทาลงเมื่อหยุดยาที่สงสัยหรือเมื่อมีการให้ specific antagonist",
          "valueEN": "3. The adverse reaction subsides when the suspected drug is discontinued or when a specific antagonist is given."
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\", borderRight: \"solid gray 2px\", \"backgroundColor\":\"rgb(161, 221, 230,0.49)\",}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "4. อาการไม่พึงประสงค์นั้นกลับเป็นซ้ำเมื่อมีการใช้ยานั้นอีก",
          "valueEN": "4. The adverse effect recurs when the drug is used again."
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\", borderRight: \"solid gray 2px\", \"backgroundColor\":\"rgb(161, 221, 230,0.49)\",}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "5. อาจมีสาเหตุอื่นนอกเหนือจากยาที่สงสัยซึ่งเป็นสาเหตุให้ผู้ป่วย มีอาการไม่พึงประสงค์นั้น",
          "valueEN": "5. There may be other causes besides the suspected drug that are causing the patient to have the adverse symptoms."
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-32"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\", borderRight: \"solid gray 2px\", \"backgroundColor\":\"rgb(161, 221, 230,0.49)\",}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "6. ปฏิกิริยาดังกล่าวนี้เกิดขึ้นอีกเมื่อให้ยาหลอกหรือไม่",
          "valueEN": "6. Did this reaction occur again when given a placebo?"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\", borderRight: \"solid gray 2px\", \"backgroundColor\":\"rgb(161, 221, 230,0.49)\",}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "7. มีการวัดระดับยาในเลือดหรือใน body fluid อื่น และค่าดังกล่าว แสดงถึงระดับที่เป็นพิษ",
          "valueEN": "7. The drug level in the blood or other body fluid has been measured and the value indicates a toxic level."
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\", borderRight: \"solid gray 2px\", \"backgroundColor\":\"rgb(161, 221, 230,0.49)\",}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "8. อาการไม่พึงประสงค์นั้นรุนแรงขึ้นเมื่อมีการเพิ่มขนาดยาและ/หรืออาการไม่พึงประสงค์นั้นลดความรุนแรงลงเมื่อลดขนาดยา",
          "valueEN": "8. The adverse reaction is more severe when the dose is increased and/or the adverse reaction is less severe when the dose is decreased."
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\", borderRight: \"solid gray 2px\", \"backgroundColor\":\"rgb(161, 221, 230,0.49)\",}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "9. ผู้ป่วยเคยแสดงอาการไม่พึงประสงค์เช่นนี้มาก่อนในอดีตเมื่อใช้ยาที่สงสัย หรือยาที่คล้ายกัน",
          "valueEN": "9. Has the patient ever shown such adverse reactions in the past when taking the suspected drug or similar drugs?"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\", borderRight: \"solid gray 2px\", \"backgroundColor\":\"rgb(161, 221, 230,0.49)\",}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "10. สามารถยืนยันอาการไม่พึงประสงค์ดังกล่าวได้ด้วย objective data",
          "valueEN": "10. Such adverse reactions can be confirmed with objective data."
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", width: \"60%\", borderRight: \"solid gray 2px\", \"backgroundColor\":\"rgb(161, 221, 230,0.49)\",}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", borderRight: \"solid gray 2px\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", borderRight: \"solid gray 2px\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", borderRight: \"solid gray 2px\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", borderRight: \"solid gray 2px\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", borderRight: \"solid gray 2px\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", borderRight: \"solid gray 2px\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", borderRight: \"solid gray 2px\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"30%\", borderRight: \"solid gray 2px\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Radio",
      "parent": 38,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"3\"] === \"YES\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-Yes-q3"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "name": {
          "type": "value",
          "value": "3"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "YES"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Radio",
      "parent": 38,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"3\"] === \"NO\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-No-q3"
        },
        "label": {
          "type": "value",
          "value": "ไม่ใช่",
          "valueEN": "no"
        },
        "name": {
          "type": "value",
          "value": "3"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NO"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Radio",
      "parent": 38,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"3\"] === \"NA\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-NA-q3"
        },
        "label": {
          "type": "value",
          "value": "ไม่ทราบ",
          "valueEN": "I don't know."
        },
        "name": {
          "type": "value",
          "value": "3"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Radio",
      "parent": 39,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"4\"] === \"YES\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-Yes-q4"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "name": {
          "type": "value",
          "value": "4"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "YES"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Radio",
      "parent": 39,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"4\"] === \"NO\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-No-q4"
        },
        "label": {
          "type": "value",
          "value": "ไม่ใช่",
          "valueEN": "no"
        },
        "name": {
          "type": "value",
          "value": "4"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NO"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Radio",
      "parent": 39,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"4\"] === \"NA\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-NA-q4"
        },
        "label": {
          "type": "value",
          "value": "ไม่ทราบ",
          "valueEN": "I don't know."
        },
        "name": {
          "type": "value",
          "value": "4"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Radio",
      "parent": 40,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"5\"] === \"YES\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-Yes-q5"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "name": {
          "type": "value",
          "value": "5"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "YES"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Radio",
      "parent": 40,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"5\"] === \"NO\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-No-q5"
        },
        "label": {
          "type": "value",
          "value": "ไม่ใช่",
          "valueEN": "no"
        },
        "name": {
          "type": "value",
          "value": "5"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NO"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Radio",
      "parent": 40,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"5\"] === \"NA\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-NA-q5"
        },
        "label": {
          "type": "value",
          "value": "ไม่ทราบ",
          "valueEN": "I don't know."
        },
        "name": {
          "type": "value",
          "value": "5"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Radio",
      "parent": 41,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"6\"] === \"YES\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-Yes-q6"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "name": {
          "type": "value",
          "value": "6"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "YES"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Radio",
      "parent": 41,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"6\"] === \"NO\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-No-q6"
        },
        "label": {
          "type": "value",
          "value": "ไม่ใช่",
          "valueEN": "no"
        },
        "name": {
          "type": "value",
          "value": "6"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NO"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Radio",
      "parent": 41,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"6\"] === \"NA\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-NA-q6"
        },
        "label": {
          "type": "value",
          "value": "ไม่ทราบ",
          "valueEN": "I don't know."
        },
        "name": {
          "type": "value",
          "value": "6"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Radio",
      "parent": 42,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"7\"] === \"YES\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-Yes-q7"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "name": {
          "type": "value",
          "value": "7"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "YES"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Radio",
      "parent": 42,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"7\"] === \"NO\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-No-q7"
        },
        "label": {
          "type": "value",
          "value": "ไม่ใช่",
          "valueEN": "no"
        },
        "name": {
          "type": "value",
          "value": "7"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NO"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Radio",
      "parent": 42,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"7\"] === \"NA\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-NA-q7"
        },
        "label": {
          "type": "value",
          "value": "ไม่ทราบ",
          "valueEN": "I don't know."
        },
        "name": {
          "type": "value",
          "value": "7"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "Radio",
      "parent": 45,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"10\"] === \"YES\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-Yes-q10"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "name": {
          "type": "value",
          "value": "10"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "YES"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Radio",
      "parent": 45,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"10\"] === \"NO\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-No-q10"
        },
        "label": {
          "type": "value",
          "value": "ไม่ใช่",
          "valueEN": "no"
        },
        "name": {
          "type": "value",
          "value": "10"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NO"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Radio",
      "parent": 45,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"10\"] === \"NA\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-NA-q10"
        },
        "label": {
          "type": "value",
          "value": "ไม่ทราบ",
          "valueEN": "I don't know."
        },
        "name": {
          "type": "value",
          "value": "10"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Radio",
      "parent": 44,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"9\"] === \"YES\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-Yes-q9"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "name": {
          "type": "value",
          "value": "9"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "YES"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Radio",
      "parent": 44,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"9\"] === \"NO\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-No-q9"
        },
        "label": {
          "type": "value",
          "value": "ไม่ใช่",
          "valueEN": "no"
        },
        "name": {
          "type": "value",
          "value": "9"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NO"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "Radio",
      "parent": 44,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"9\"] === \"NA\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-NA-q9"
        },
        "label": {
          "type": "value",
          "value": "ไม่ทราบ",
          "valueEN": "I don't know."
        },
        "name": {
          "type": "value",
          "value": "9"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "Radio",
      "parent": 43,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"8\"] === \"YES\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-Yes-q8"
        },
        "label": {
          "type": "value",
          "value": "ใช่",
          "valueEN": "yes"
        },
        "name": {
          "type": "value",
          "value": "8"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "YES"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "Radio",
      "parent": 43,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"8\"] === \"NO\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-No-q8"
        },
        "label": {
          "type": "value",
          "value": "ไม่ใช่",
          "valueEN": "no"
        },
        "name": {
          "type": "value",
          "value": "8"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NO"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Radio",
      "parent": 43,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjo?.[\"8\"] === \"NA\" "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Radio-NA-q8"
        },
        "label": {
          "type": "value",
          "value": "ไม่ทราบ",
          "valueEN": "I don't know."
        },
        "name": {
          "type": "value",
          "value": "8"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjo"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft:\"25px\"}"
        },
        "value": {
          "type": "value",
          "value": "NA"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "props.score?.[\"3\"] || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "code",
          "value": "props.score?.[\"4\"] || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-71"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "code",
          "value": "props.score?.[\"5\"] || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "code",
          "value": "props.score?.[\"6\"] || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.score?.[\"7\"] || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "code",
          "value": "props.score?.[\"8\"] || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-75"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.score?.[\"9\"] || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "code",
          "value": "props.score?.[\"10\"] || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\", padding: \"10px\", width: \"10%\", }"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\", margin: \"20px 0px\" }"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 78,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{ justifyContent: \"space-between\", display: \"flex\", padding: \"10px\", width: \"65%\", borderRight: \"solid gray 2px\", backgroundColor:\"rgba(255, 208, 43, 0.46)\",}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-81"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 30px\", display: \"flex\", color: \"#1B75BB\",  fontWeight: \"bold\", fontSize: \"17px\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 30px\", display: \"flex\", color: \"#1B9D2C\",  fontWeight: \"bold\", fontSize: \"17px\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": "คะแนนรวม :",
          "valueEN": "Total score :"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-83"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "code",
          "value": "props.naranjo?.score || 0"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-84"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": "ผลการประเมิน: "
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-85"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 82,
      "props": {
        "children": {
          "type": "code",
          "value": "props.naranjo?.status || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Button",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "record"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Button-87"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSave"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Button",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "cancel"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardNaranjoAlgorithmUX-Button-88"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCencel"
        }
      },
      "seq": 88,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardNaranjoAlgorithmUX",
  "project": "New Project",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
